import React from 'react';
import { useTokens } from '../../../../../context/TokenProvider';
import { localise, templateReplace } from '../../../../../services/lang/lang';
import { getCreatorName } from '../../../../../services/text/getCreatorName';
import { Alert } from '../../../../modules/Alert/Alert';
const InspectionDetailCompletedAlert = ({ inspection }) => {
    const tokens = useTokens();
    return (React.createElement(Alert, { "data-testid": "inspection-detail-content__alert", status: "warning", mb: tokens.Spacing04, icon: true, title: localise('INSPECTION_MARKED_AS_COMPLETE_TITLE') }, templateReplace(localise('INSPECTION_MARKED_AS_COMPLETE_DESC'), {
        creator: getCreatorName(inspection),
        completed_date: inspection._formatted.completed_date,
    })));
};
export default InspectionDetailCompletedAlert;
